// extracted by mini-css-extract-plugin
export var label = "_bt-1";
export var reminder = "_bt-0";